import STORE from "../context";
import Fetcher from "../fetcher";
import Supports from "../utils/supports";
import SearchParams, { getParams } from "./searchparams";
import ErrorState from "../context/common/error";
import { isPlainObject, getValueAtPath } from "../utils";

import {
  DEFAULT_POST_INIT,
  DEFAULT_RETRY_CONDITIONS,
  DEFAULT_TIMEOUT,
  isJsonResponse,
  withSharedHeaders
} from "../fetcher/utils";

// Initialization data
let INITIALIZATION_DATA;
let INITIALIZATION_ERROR;

const API_BASE_URL = process.env.API_BASE_URL;
const INITIALIZATION_API_ENDPOINT = `${API_BASE_URL}/v3/checkout/initialize`;

const ERR_INITIALIZATION_FAILURE = (function __initializationFailureError__() {
  const err = new Error('INITIALIZATION_FAILED');
  err.name = 'ERR_INITIALIZATION_FAILURE';
  return Object.freeze(err);
})();

const $fetch = withSharedHeaders(Fetcher.one
  .limit(5)
  .init(DEFAULT_POST_INIT)
  .retry(...DEFAULT_RETRY_CONDITIONS)
  .timeout(DEFAULT_TIMEOUT * 2));

const PREFERRED_PAYMENT_OPTIONS_SEQUENCE = [
  'card', 'paypal', 'applepay', 'googlepay', 'ussd', 'account', 'banktransfer', 'internetbanking', 'enaira', 'mobilemoneyfranco', 'mobilemoneyghana', 'mobilemoneymalawi',
  'mobilemoneyrwanda', 'mobilemoneytanzania', 'mobilemoneyuganda', 'mobilemoneyzambia', 'mpesa', '1voucher', 'qr',
  'barter', 'opay', 'bankreference', 'fawrypay', 'payattitude', 'paga', 'nqr', 'credit', 'wechat', 'cryptocurrency', 'mcash', 'alipay'
];

function __fetchInitializationData__() {
  if (SearchParams.hasErrors()) {
    return new Promise((_, reject) => {
      setTimeout(reject, 100)
    })
  }
  return $fetch(INITIALIZATION_API_ENDPOINT, {
    body: JSON.stringify({
      ...getParams(
        'amount',
        'country',
        'currency',
        'customer_email',
        'disable_pwb',
        'init_url',
        'integrity_hash',
        'checkout_hash',
        'payload_hash',
        'payment_plan',
        'payment_method',
        'payment_options',
        'PBFPubKey::public_key',
        'txref::tx_ref'
      ),
      last_used_payment_option: Supports.localStorage ? localStorage.getItem('lastUsedOption') : null,
      payment_options_sequence: `${PREFERRED_PAYMENT_OPTIONS_SEQUENCE}`
    })
  }).then(response => {
    INITIALIZATION_ERROR = null;

    if (isJsonResponse(response)) {
      return response.json()
        .then(response => {
          try {
            if (response.status === 'error') {
              INITIALIZATION_ERROR = response.message || null;
              return Promise.reject(ERR_INITIALIZATION_FAILURE);
            }
          } catch (e) {}

          if (isPlainObject(response) && isPlainObject(response.data)) {

            const initResponse = { ...response.data };

            for (const key in initResponse.payment_options) {
              const payment_options_arr = initResponse.payment_options[key]; 

              if (Array.isArray(payment_options_arr)) {
                ["mobilemoneyxaf", "mobilemoneyxof"].forEach(opt => {
                  const payment_index = payment_options_arr.indexOf(opt);            
                  if (payment_index !== -1) {
                    initResponse.payment_options[key][payment_index] = "mobilemoneyfranco";
                  }
                });                                    
              }
            };

            const $initData = initResponse;

            // const numberOfRetries = 'custom_retry' in SearchParams.raw ? (SearchParams.get('custom_retry') || 0) : null;
            // if (numberOfRetries !== null) {
            //   // TODO: consider using state if LS isn't available
            //   Supports.localStorage 
            //     ? localStorage.setItem('retryAttempts', btoa(String(Math.round(Number(numberOfRetries)) * 100))) 
            //     : void 0;
            // }

            const numberOfRetriesFromParam = 'custom_retry' in SearchParams.raw
             ? (SearchParams.get('custom_retry') || 0)
             : null;

           let effectiveRetries = numberOfRetriesFromParam;

           const cardIsAvailable = (function () {
             const options = initResponse.payment_options || {};
             return Object.values(options).some(opts => Array.isArray(opts) && opts.includes('card'));
           })();

           if (effectiveRetries === null && cardIsAvailable) {
             effectiveRetries = 10;
           }

           if (effectiveRetries !== null) {
             const encoded = btoa(String(Math.round(Number(effectiveRetries)) * 100));
             Supports.localStorage ? localStorage.setItem('retryAttempts', encoded) : void 0;
           }
            Object.defineProperty($initData, 'get', {
              value(path) {
                const value = getValueAtPath($initData, path);
                return value === undefined ? null : value;
              }
            });

            return (INITIALIZATION_DATA = $initData);
          }

          return Promise.reject(ERR_INITIALIZATION_FAILURE);
        });
    }

    return Promise.reject(ERR_INITIALIZATION_FAILURE);
  });
}

function __getInitializationData__() {
  return INITIALIZATION_DATA
    ? Promise.resolve(INITIALIZATION_DATA)
    : __fetchInitializationData__()
      .catch(() => {
        let message = INITIALIZATION_ERROR || "Initialization failed";
        
        if (message && (message = message.replace(/\.?\s*?$/, "").trim())) {
          setTimeout(() => {
            let errorMessage = `${message}: Kindly terminate this session and try again.`

            switch (message) {
              case 'Initialization failed':
                errorMessage = "init.generic.notice";
                break;
            }

            SearchParams.hasErrors() || STORE.dispatch(
              ErrorState.actions.updateErrorMessage(
                errorMessage
              )
            );
          }, 100);
        }

        return (INITIALIZATION_DATA = Object.create(null, {
          get: { value: () => null }
        }));
      });
}

export {
  ERR_INITIALIZATION_FAILURE,
  PREFERRED_PAYMENT_OPTIONS_SEQUENCE,
  __fetchInitializationData__ as refresh,
  __getInitializationData__ as get
};
